import Asset3D from "./Asset3D";
import { SceneAssetProps } from "./types";

export type NVSScene3DAssetsProps = { assets?: SceneAssetProps[] };

const NVSScene3DAssets: React.FC<NVSScene3DAssetsProps> = ({ assets }) => (
  <>
    {assets?.map((asset3D, index) => {
      return <Asset3D key={index} {...asset3D} />;
    })}
  </>
);

export default NVSScene3DAssets;
